import React from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import bookings from "../../images/bookings.svg";
import Accordion from "../../components/Accordion/Accordion";

function FAQ() {
  const navigate = useNavigate();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const data = [
    {
      id: 1,
      question: "How do I login to BUK?",
      answer:
        "You can login to BUK using your Metamask wallet - just click on the Connect Wallet button on the top right and authorize the connect using the Metamask pop-up. If Metamask doesn’t pop-up on its own (happens sometime!), just click on your Metamask icon to see any pending authorization requests. Let the Fox do its thing!",
    },
    {
      id: 2,
      question:
        "When I try to book a hotel, the authorization pop-up ask for a higher price permission than the room price, why?",
      answer:
        "We take authorization for a slightly higher amount to avoid any chances of decline when BUK sends the actual debit instruction. Note that the authorization does not automatically authorize BUK platform to debit the amount, you will be prompted again before we debit your wallet. In fact this is a safer option, then taking unlimited approvals, as most other DeFi sites do.",
    },
    {
      id: 3,
      question:
        "Why does BUK ask for authorization twice for a single booking?",
      answer:
        "BUK takes two separate authorizations - one for the Booking value of the hotel and another for the Gas fees on the transaction.",
    },
    {
      id: 4,
      question: "How does BUK make money?",
      answer:
        "BUK charges a 5% platform fee for every booking and 1% platform fee for every trade. This amount is added in your total payout when you reach the booking confirmation screen.",
    },
    {
      id: 5,
      question: "How do I trade my booking?",
      answer:
        "After you’ve booked a room, click on the Menu on the top right and select ‘My Bookings’. Once done, you will see all your bookings on the page with the button ‘List for Sale’ for each one of them.",
    },
    {
      id: 6,
      question: "Can I gift my booking / transfer booking to someone else?",
      answer:
        "Yes - Only once. Use the Check-in option against your booking, in your MyBooking page. Provide details of the person you are transferring/gifting the booking to. No royalties or charges applied on this. But - once checked-in, bookings are non-cancellable and nontransferable.",
    },
    {
      id: 7,
      question:
        "Why is the refund amount calculated, in case of a cancellation?",
      answer:
        "Cancellation charges are a factor of the primary buy price, as its calculated as a percentage of the primary buy (First purchase directly from Hotel). The refund amount becomes absolute after this. For secondary buys, the refund amount will continue to be the Primary buyers refund amount.",
    },
    {
      id: 8,
      question:
        "Why am I getting multiple NFTs for a single booking? Are these duplicates? Is it bug?",
      answer:
        "None of them. It is by design. WE have broken down each booking to an inidividual room night level and each NFT represents the Roomnight combination. This gives user the flexibility of breaking up their booking and selling it as individual NFTs/ bookings.",
    },
    {
      id: 9,
      question:
        "What happens if no one buys my booking from the secondary market?",
      answer:
        "You could still use your booking to stay in the room that you booked/bought. If before the cancellation deadline as mentioned in the booking summary page, you have the option of cancellation and getting a refund as per cancellation guidelines. If after the cancellation deadline, you can either stay in the hotel or it will be treated as a no-show. Trust me no one wins in this scenario. So make informed buy-choices and keep a watchful eye on the cancellation/trading deadline.",
    },
    {
      id: 10,
      question: "What about my hotel membership points?",
      answer:
        "You can inform the checkin desk at the time of checkin of your membership details and avail the applicable rewards as issued by the individual hotel or chain.",
    },
    {
      id: 11,
      question:
        "Can I change my room to double occupancy? Or customise my stay in anyway?",
      answer:
        "All our rooms are single occupancy for the Lisbon event. In case of additional occupancy or any other customisation requirements, please seek clarification and make payments directly at the hotel.",
    },
    {
      id: 12,
      question: "Can I check-in early or check-out late?",
      answer: "Please sort it out directly with the hotel.",
    },
    {
      id: 13,
      question:
        "I did not receive the booking related NFT or the cancellation amount. What do I do?",
      answer: "Reach out to support at https://t.me/buk_tech",
    },
    {
      id: 14,
      question: "Can I receive my refund amount in cash or bank account?",
      answer:
        "Nopes. The wallet you transacted with is the one that gets the refund.",
    },
  ];

  return (
    <div className="bg-[#F7F9FB] pb-20">
      <Helmet>
        <meta charSet="utf-8" />
        <title>FAQ</title>
      </Helmet>

      <div onClick={() => navigate(-1)}>
        <svg
          className="ml-7 mt-2"
          width="151"
          height="17"
          viewBox="0 0 151 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.494 14V4.2H26.19C27.2073 4.2 27.9773 4.438 28.5 4.914C29.0227 5.39 29.284 5.98733 29.284 6.706C29.284 7.33133 29.116 7.83067 28.78 8.204C28.444 8.568 28.038 8.81533 27.562 8.946C27.9353 9.02067 28.2667 9.17 28.556 9.394C28.8547 9.618 29.088 9.898 29.256 10.234C29.424 10.57 29.508 10.934 29.508 11.326C29.508 11.83 29.382 12.2873 29.13 12.698C28.8873 13.0993 28.528 13.4167 28.052 13.65C27.576 13.8833 26.9927 14 26.302 14H22.494ZM23.978 8.4H26.008C26.5773 8.4 27.0113 8.26933 27.31 8.008C27.6087 7.73733 27.758 7.36867 27.758 6.902C27.758 6.44467 27.6087 6.08067 27.31 5.81C27.0207 5.53933 26.5773 5.404 25.98 5.404H23.978V8.4ZM23.978 12.782H26.106C26.7033 12.782 27.1653 12.642 27.492 12.362C27.828 12.082 27.996 11.69 27.996 11.186C27.996 10.682 27.8233 10.2853 27.478 9.996C27.1327 9.69733 26.666 9.548 26.078 9.548H23.978V12.782ZM33.4306 14.168C32.8426 14.168 32.3573 14.07 31.9746 13.874C31.592 13.678 31.3073 13.4213 31.1206 13.104C30.934 12.7773 30.8406 12.4227 30.8406 12.04C30.8406 11.368 31.102 10.836 31.6246 10.444C32.1473 10.052 32.894 9.856 33.8646 9.856H35.6846V9.73C35.6846 9.18867 35.5353 8.78267 35.2366 8.512C34.9473 8.24133 34.5693 8.106 34.1026 8.106C33.692 8.106 33.3326 8.20867 33.0246 8.414C32.726 8.61 32.544 8.904 32.4786 9.296H30.9946C31.0413 8.792 31.2093 8.36267 31.4986 8.008C31.7973 7.644 32.1706 7.36867 32.6186 7.182C33.076 6.986 33.5753 6.888 34.1166 6.888C35.0873 6.888 35.8386 7.14467 36.3706 7.658C36.9026 8.162 37.1686 8.85267 37.1686 9.73V14H35.8806L35.7546 12.81C35.5586 13.1927 35.274 13.5147 34.9006 13.776C34.5273 14.0373 34.0373 14.168 33.4306 14.168ZM33.7246 12.964C34.126 12.964 34.462 12.8707 34.7326 12.684C35.0126 12.488 35.2273 12.2313 35.3766 11.914C35.5353 11.5967 35.6333 11.2467 35.6706 10.864H34.0186C33.4306 10.864 33.0106 10.9667 32.7586 11.172C32.516 11.3773 32.3946 11.634 32.3946 11.942C32.3946 12.2593 32.5113 12.5113 32.7446 12.698C32.9873 12.8753 33.314 12.964 33.7246 12.964ZM42.1889 14.168C41.5076 14.168 40.8963 14.014 40.3549 13.706C39.8229 13.398 39.4029 12.9733 39.0949 12.432C38.7963 11.8813 38.6469 11.2467 38.6469 10.528C38.6469 9.80933 38.7963 9.17933 39.0949 8.638C39.4029 8.08733 39.8229 7.658 40.3549 7.35C40.8963 7.042 41.5076 6.888 42.1889 6.888C43.0476 6.888 43.7663 7.112 44.3449 7.56C44.9329 8.008 45.3109 8.61467 45.4789 9.38H43.9249C43.8316 8.99733 43.6263 8.69867 43.3089 8.484C42.9916 8.26933 42.6183 8.162 42.1889 8.162C41.8249 8.162 41.4889 8.25533 41.1809 8.442C40.8729 8.61933 40.6256 8.88533 40.4389 9.24C40.2523 9.58533 40.1589 10.0147 40.1589 10.528C40.1589 11.0413 40.2523 11.4753 40.4389 11.83C40.6256 12.1753 40.8729 12.4413 41.1809 12.628C41.4889 12.8147 41.8249 12.908 42.1889 12.908C42.6183 12.908 42.9916 12.8007 43.3089 12.586C43.6263 12.3713 43.8316 12.068 43.9249 11.676H45.4789C45.3203 12.4227 44.9469 13.0247 44.3589 13.482C43.7709 13.9393 43.0476 14.168 42.1889 14.168ZM47.0884 14V3.92H48.5724V9.926L51.2324 7.056H53.0104L50.0564 10.206L53.4444 14H51.5684L48.5724 10.444V14H47.0884Z"
            fill="#2F69FF"
          />
          <path
            d="M0.646447 9.64644C0.451184 9.8417 0.451184 10.1583 0.646446 10.3535L3.82842 13.5355C4.02369 13.7308 4.34027 13.7308 4.53553 13.5355C4.73079 13.3403 4.73079 13.0237 4.53553 12.8284L1.70711 9.99999L4.53554 7.17157C4.7308 6.97631 4.7308 6.65972 4.53554 6.46446C4.34028 6.2692 4.02369 6.2692 3.82843 6.46446L0.646447 9.64644ZM11.5 9.5L1 9.49999L1 10.5L11.5 10.5L11.5 9.5Z"
            fill="#2F69FF"
          />
        </svg>
      </div>
      <p className="text-center sell py-4 ">FAQ</p>
      <div className="mx-auto mt-12 mb-11 w-10/12">
        <Accordion data={data} />
      </div>
    </div>
  );
}

export default FAQ;
